import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const verifyToken = useCallback(async () => {
    try {
      const token = localStorage.getItem('merchant_token');
      if (!token) { setLoading(false); return; }

      const response = await api.get('/auth/me');
      if (response.data && response.data.role === 'merchant') {
        setIsAuthenticated(true);
        setUser(response.data);
      } else {
        localStorage.removeItem('merchant_token');
      }
    } catch {
      localStorage.removeItem('merchant_token');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { verifyToken(); }, [verifyToken]);

  const login = async (email, password) => {
    try {
      const response = await api.post('/auth/merchant/login', { email, password });
      const { token, user } = response.data;
      localStorage.setItem('merchant_token', token);
      setIsAuthenticated(true);
      setUser(user);
      return { success: true };
    } catch (error) {
      return { success: false, message: error.response?.data?.message || 'Нэвтрэхэд алдаа гарлаа' };
    }
  };

  const logout = () => {
    localStorage.removeItem('merchant_token');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
